import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import useUserStore from 'store/user';
import { S3_URL } from 'constants/index';
import useCommonStore from 'store/common';

const VideoPlayer: React.FC<any> = () => {
	const { profileData }: any = useUserStore((state) => state);
	const { modalConfig = {} }: any = useCommonStore((state) => state);

	return (
		<Modal.Body>
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => modalConfig?.onClose()}
				aria-label="Close"
				title="Close"
			>
				<i className="ri-close-line" aria-hidden="true"></i>
			</Button>
			<div style={{ position: 'relative', paddingTop: '56.25%' }}>
				<ReactPlayer
					url={`${S3_URL}${profileData?.videoResume}`}
					controls
					playing
					width="100%"
					height="100%"
					style={{ position: 'absolute', top: 0, left: 0 }}
					onError={(error) => {
						// Handle video playback errors gracefully
						console.warn('Video playback error:', error);
					}}
				/>
			</div>
		</Modal.Body>
	);
};

export default VideoPlayer;
